import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCalendarAlt, FaUser } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";
import "../css/Blog.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "../helpers/dateFormat";

const Blog = () => {
  const { t, i18n } = useTranslation();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_APP_URL}/blogs`,
        {
          headers: {
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
          withCredentials: true,
        }
      );
      if (response.data.success && Array.isArray(response.data.data)) {
        setBlogs(response.data.data);
      } else {
        setBlogs([]);
      }
    } catch (error) {
      console.error("Error fetching blog data:", error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, [i18n.language]);

  const handleReadMore = (slug) => {
    navigate(`/blog/${slug}`);
  };

  if (loading) {
    return (
      <div className="container" style={{ marginTop: "80px" }}>
        <div className="row row-cols-12 row-cols-md-12 row-cols-lg-12 g-4 blog-loading-container">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="col">
              <div className="card blog-loading-card">
                <div className="blog-loading-image"></div>
                <div className="blog-loading-body">
                  <div className="blog-loading-title"></div>
                  <div
                    className="blog-loading-line"
                    style={{ width: "80%" }}
                  ></div>
                  <div
                    className="blog-loading-line"
                    style={{ width: "90%" }}
                  ></div>
                  <div
                    className="blog-loading-line"
                    style={{ width: "70%" }}
                  ></div>
                  <div className="blog-loading-button"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!blogs.length) {
    return (
      <div className="container" style={{ marginTop: "80px" }}>
        <p>{t("No blogs available")}</p>
      </div>
    );
  }

  return (
    <div className="container" style={{ marginTop: "80px" }}>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        {blogs.map((blog) => {
          const imageUrl = `${process.env.REACT_APP_STORAGE_URL}/${blog.image}`;
          return (
            <div key={blog.slug} className="col">
              <div className="card blog-card h-100 shadow-lg border-0 rounded-4 overflow-hidden animate__animated animate__fadeInUp animate__delay-1s">
                <div className="position-relative">
                  <img
                    src={imageUrl}
                    alt={blog.title}
                    className="card-img-top"
                  />
                  <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>
                </div>
                <div className="card-body d-flex flex-column p-4">
                  <h5 className="card-title fw-bold text-dark">{blog.title}</h5>
                  <p className="text-muted small d-flex align-items-center">
                    <FaUser className="me-1 text-primary" /> {blog.user_name}{" "}
                    &nbsp; | &nbsp;
                    <FaCalendarAlt className="me-1 text-primary" />{" "}
                    {formatDateTime(blog.created_at)}
                  </p>
                  <p className="card-text flex-grow-1 text-secondary">
                    {blog.excerpt}
                  </p>
                  <button
                    onClick={() => handleReadMore(blog.slug)}
                    className="btn btn-outline-primary w-100 mt-auto fw-bold"
                  >
                    {t("readMore")}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Blog;
